import "@lds/core/lds-button.js"
import "@lds/core/lds-select.js"
import "@lds/core/lds-option.js"
import "@lds/core/lds-dropdown.js"

import "./pagination/pagination.ts"
import "../global/pagination/pagination.css"
import "./pagination/index.ts"
import "./pagination/buttons.ts"
import "./pagination/select.ts"

import "../events-slider/events-slider.ts"
import "../events-slider/events-slider.css"

import "../news/advert-banners.ts"
import "../azm/advert-cards.css"

import { initBottomAnnouncements } from "@modules/news/bottom-announcements.ts"
import { initTopAnnouncements } from "@modules/news/top-announcements.ts"

document.addEventListener("DOMContentLoaded", initTopAnnouncements)
document.addEventListener("DOMContentLoaded", initBottomAnnouncements)
